<div class="d-flex justify-content-center align-items-center p-5">
  <div class="bg-white shadow rounded p-4 w-100">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="text-dark">{{ translationService.getTranslation('Exam Folders') }}</h3>
      <button class="btn btn-success" (click)="addFolder()">{{ translationService.getTranslation('Add New Folder') }}</button>
    </div>

    <div class="table-responsive">
      <table class="table table-bordered table-striped table-hover">
        <thead class="table-success">
          <tr>
            <th scope="col">{{ translationService.getTranslation('Course Name') }}</th>
            <th scope="col">{{ translationService.getTranslation('Course Units') }}</th>
            <th  class="text-center" scope="col">{{ translationService.getTranslation('Action') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let folder of allExamFolders">
            <td>{{ folder["Course Name"] }}</td>
            <td>{{ folder["Course Units Count"] }}</td>
            <td class="text-center">
              <i class="bi bi-eye text-primary me-2" (click)="viewFolder(folder)" style="cursor: pointer;"></i>
              <i class="bi bi-pencil-square text-secondary me-2" (click)="editFolder(folder)" style="cursor: pointer;"></i>
              <i class="bi bi-trash text-danger me-2" (click)="deleteFolder(folder)" style="cursor: pointer;"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="showErrorMessage" class="alert alert-danger">
      <p>{{ translationService.getTranslation('There are Questions in this folder, pleace remove them first') }}</p>
    </div>
  </div>
</div>

<div *ngIf="viewFolderModal" class="modal fade show" tabindex="-1" role="dialog" aria-hidden="true" style="display: block;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ selectedFolder?.["Course Name"] || 'Untitled Course' }}</h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <ul>
          <li *ngFor="let unit of UnitDTO">
            <i class="bi bi-file-earmark"></i> {{ unit["Unit Name"] }}
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          <i class="bi bi-x-circle"></i> {{ translationService.getTranslation('Close') }}
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="addFolderModal" class="modal fade show" tabindex="-1" role="dialog" aria-hidden="true" style="display: block;">
  <div class="modal-dialog w-100" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ translationService.getTranslation('Add New Folder') }}</h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="submitAddFolder()">
          <div class="mb-3">
            <label for="folderName" class="form-label">{{ translationService.getTranslation('Course Name') }}</label>
            <input type="text" class="form-control" id="folderName" [(ngModel)]="folderName" name="folderName" required autocomplete="off" />
          </div>
          <div class="d-flex justify-content-between mb-2">
            <label class="form-label">{{ translationService.getTranslation('Course Units') }} </label>
            <button type="button" class="btn btn-success btn-sm ms-2" (click)="addUnit()">
              <i class="bi bi-plus-circle"></i> {{ translationService.getTranslation('New Unit') }}
            </button>
          </div>
          <div *ngFor="let unit of folderDTO.UnitsDetails; let i = index" class="mb-3 d-flex justify-content-between align-items-center">
            <i class="bi bi-file-earmark px-2"></i>
            <input type="text" class="form-control me-3" [(ngModel)]="unit.UnitName" [name]="'unit' + i" required autocomplete="off" />
            <div class="d-flex align-items-center">
              <button type="button" class="btn btn-danger btn-sm me-2" *ngIf="folderDTO.UnitsDetails.length > 1"  (click)="removeUnit(i)">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
          <div class="d-flex justify-content-between mt-4">
            <button type="submit" class="btn btn-primary" [disabled]="!isFormValid()">
              <i class="bi bi-save"></i> {{ translationService.getTranslation('Save Folder') }}
            </button>            
            <button type="button" class="btn btn-secondary" (click)="closeModal()">
              <i class="bi bi-x-circle"></i> {{ translationService.getTranslation('Cancel') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div *ngIf="editFolderModal" class="modal fade show" tabindex="-1" role="dialog" aria-hidden="true" style="display: block;">
  <div class="modal-dialog w-100" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ translationService.getTranslation('Edit Course') }}: {{ selectedFolder["Course Name"]}}</h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="submitEditFolder(selectedFolder)">
          <div class="mb-3">
            <label for="courseName" class="form-label">{{ translationService.getTranslation('Course Name') }}</label>
            <input type="text" class="form-control" id="courseName" [(ngModel)]="editCourseName" name="courseName" required autocomplete="off" />
          </div>

          <div class="mb-3">
            <div class="d-flex justify-content-between mb-2">
              <label class="form-label mb-0">{{ translationService.getTranslation('Units') }}</label>
              <button type="button" class="btn btn-success btn-sm" (click)="addEditUnit()">
                <i class="bi bi-plus-circle"></i> {{ translationService.getTranslation('New Unit') }}
              </button>
            </div>
            <ul class="list-group mb-2">
              <li *ngFor="let unit of UnitDTO; let i = index" class="list-group-item d-flex justify-content-between align-items-center w-100">
                <span class="d-flex align-items-center w-100">
                  <i class="bi bi-file-earmark me-2"></i>
                  <input type="text" class="form-control w-100" [(ngModel)]="unit['Unit Name']" [name]="'unit' + i" required autocomplete="off" />
                </span>
                <button type="button" class="btn btn-danger btn-sm ms-2" *ngIf="UnitDTO.length > 1" (click)="removeEditUnit(i)">
                  <i class="bi bi-trash"></i>
                </button>
              </li>
            </ul>
          </div>
          

          <div class="d-flex justify-content-between mt-4">
            <button type="submit" class="btn btn-primary" [disabled]="!isEditFormValid()">
              <i class="bi bi-save"></i> {{ translationService.getTranslation('Save Changes') }}
            </button>
            <button type="button" class="btn btn-secondary" (click)="closeModal()">
              <i class="bi bi-x-circle"></i> {{ translationService.getTranslation('Cancel') }}
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>


<div *ngIf="deleteConfirmationModal" class="modal fade show" tabindex="-1" role="dialog" aria-hidden="true" style="display: block;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ translationService.getTranslation('Confirm Deletion') }}</h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>{{ translationService.getTranslation('Are you sure you want to delete this folder?') }}</p>
        <p class="mb-0"><strong>{{ selectedFolder?.['Course Name'] }}</strong></p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          <i class="bi bi-x-circle"></i> {{ translationService.getTranslation('Cancel') }}
        </button>
        <button type="button" class="btn btn-danger" (click)="confirmDelete()">
          <i class="bi bi-trash"></i> {{ translationService.getTranslation('Confirm') }}
        </button>
      </div>
    </div>
  </div>
</div>
